import { logStackTraceApi } from '@core/core/api'
import { isAxiosError } from 'axios'

const unhandledRejectionHandler = (promiseRejectionEvent: PromiseRejectionEvent) => {
  if (promiseRejectionEvent.reason instanceof Error || isAxiosError(promiseRejectionEvent.reason)) {
    logStackTraceApi(
      promiseRejectionEvent.reason.message,
      promiseRejectionEvent.reason.stack?.toString() ?? 'Script Error',
    )
  } else {
    logStackTraceApi('Script Error', 'Script Error')
  }
}

const errorHandler = (errorEvent: ErrorEvent) => {
  if (errorEvent.error instanceof Error) {
    logStackTraceApi(errorEvent.error.message, errorEvent.error.stack?.toString() ?? 'Script Error')
  } else {
    logStackTraceApi('Script Error', 'Script Error')
  }
}

let isEnabled = false

export const loggingExceptionListeners = {
  enable() {
    if (isEnabled) {
      return
    }

    window.addEventListener('error', errorHandler)
    window.addEventListener('unhandledrejection', unhandledRejectionHandler)
    isEnabled = true
  },
  disable() {
    window.removeEventListener('error', errorHandler)
    window.removeEventListener('unhandledrejection', unhandledRejectionHandler)
    isEnabled = false
  },
}
